"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const quotes = [{
  quote: "Their love is a testament to patience and understanding. I've never seen two people more perfectly suited for each other.",
  name: "Eleanor Vance",
  relationship: "Mother of the Bride",
  avatarSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/avatar_eleanor.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/avatar_eleanor.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/avatar_eleanor.png-wvc-sizes"
}, {
  quote: "From the moment they met, it was clear this was something special. A true modern romance built on deep mutual respect.",
  name: "James Sterling",
  relationship: "Best Man",
  avatarSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/avatar_james.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/avatar_james.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/avatar_james.png-wvc-sizes"
}, {
  quote: "Watching them grow together has been the greatest joy. They bring out the absolute best in one another.",
  name: "Clara Hughes",
  relationship: "Maid of Honor",
  avatarSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/avatar_clara.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/avatar_clara.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/avatar_clara.png-wvc-sizes"
}];
export default function WordsOfLove() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [api, setApi] = React.useState<CarouselApi>();
  const [canScrollPrev, setCanScrollPrev] = React.useState(false);
  const [canScrollNext, setCanScrollNext] = React.useState(false);
  React.useEffect(() => {
    if (!api) return;
    setCanScrollPrev(api.canScrollPrev());
    setCanScrollNext(api.canScrollNext());
    api.on("select", () => {
      setCanScrollPrev(api.canScrollPrev());
      setCanScrollNext(api.canScrollNext());
    });
  }, [api]);
  return <section id="words-of-love" className="py-24 md:py-32 bg-background overflow-hidden" ref={ref}>
      <div className={`container mx-auto px-6 max-w-5xl transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <Carousel setApi={setApi} className="w-full">
          <CarouselContent>
            {quotes.map((item, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center text-center px-4 md:px-12">
                  <p className="font-serif text-3xl md:text-4xl lg:text-5xl leading-tight md:leading-tight text-foreground mb-12 max-w-4xl mx-auto">
                    "{item.quote}"
                  </p>
                  <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6">
                    <SafeHydrate><Avatar className="size-16 md:size-20 border border-border rounded-lg">
                      <AvatarImage src={item.avatarSrc} data-wvc-srcset={item.avatarSrcset} data-wvc-sizes={item.avatarSizes} alt={item.name} className="rounded-lg object-cover" />
                      <AvatarFallback className="font-serif text-xl rounded-lg bg-muted text-muted-foreground">
                        {item.name.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div className="text-center md:text-left">
                      <div className="font-default font-semibold text-foreground text-lg md:text-xl">{item.name}</div>
                      <div className="text-muted-foreground text-sm tracking-widest uppercase mt-1">{item.relationship}</div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>

        <div className="flex justify-center items-center gap-8 mt-20">
          <Button variant="ghost" className="text-muted-foreground hover:text-foreground uppercase tracking-widest text-xs font-medium transition-colors px-2" onClick={() => api?.scrollPrev()} disabled={!canScrollPrev}>
            Prev
          </Button>
          <div className="w-16 h-[1px] bg-border"></div>
          <Button variant="ghost" className="text-muted-foreground hover:text-foreground uppercase tracking-widest text-xs font-medium transition-colors px-2" onClick={() => api?.scrollNext()} disabled={!canScrollNext}>
            Next
          </Button>
        </div>
      </div>
    </section>;
}